import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useLanguage } from '../context/LanguageContext';

const { FiFacebook, FiYoutube, FiArrowUp } = FiIcons;

const Footer = () => {
  const { t } = useLanguage();
  
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-primary-green text-white py-12">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          {/* Links */}
          <div className="flex flex-wrap justify-center md:justify-start gap-6 mb-6 md:mb-0">
            <Link
              to="/bilder"
              className="hover:text-accent-green transition-colors duration-300"
            >
              {t('footer.images')}
            </Link>
            <Link
              to="/imprint"
              className="hover:text-accent-green transition-colors duration-300"
            >
              {t('footer.imprint')}
            </Link>
            <Link
              to="/integritetspolicy"
              className="hover:text-accent-green transition-colors duration-300"
            >
              {t('footer.privacy')}
            </Link>
            <a 
              href="https://alitero.eu/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-accent-green transition-colors duration-300"
            >
              {t('footer.alitero')}
            </a>
          </div>

          {/* Social Icons */}
          <div className="flex items-center space-x-4">
            <a
              href="https://www.facebook.com/svansele.gront"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-accent-green transition-colors duration-300"
            >
              <SafeIcon icon={FiFacebook} className="w-6 h-6" />
            </a>
            <a
              href="https://www.youtube.com/channel/UCP_hE44kdHSX7cjiPFMh3IA"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-accent-green transition-colors duration-300"
            >
              <SafeIcon icon={FiYoutube} className="w-6 h-6" />
            </a>
          </div>
        </div>

        {/* Copyright and Logo */}
        <div className="mt-8 pt-8 border-t border-white/20">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-white/80 text-center md:text-left mb-4 md:mb-0">
              {t('footer.copyright')}
            </p>
            <img 
              src="./images/logo.webp" 
              alt="Logo" 
              className="h-16 w-auto"
            />
          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <motion.button
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        onClick={scrollToTop}
        className="fixed bottom-6 right-6 bg-accent-green hover:bg-green-600 text-white p-3 rounded-full shadow-lg transition-all duration-300 z-50"
      >
        <SafeIcon icon={FiArrowUp} className="w-5 h-5" />
      </motion.button>
    </footer>
  );
};

export default Footer;